export default {
  handlePermission,
};

async function handlePermission(dispatch) {
  try {
    const cameraPermission = await navigator.permissions.query({ name: 'camera' });
    const audioPermission = await navigator.permissions.query({ name: 'microphone' });

    if (cameraPermission.state === 'granted' && audioPermission.state === 'granted') {
      // Permission granted, you can access the camera.
      return true;
    } else if (cameraPermission.state === 'granted' && audioPermission.state != 'granted') {
      //if audio permission is not granted
      return handleAskAudioPermission(dispatch);
    } else if (cameraPermission.state != 'granted' && audioPermission.state === 'granted') {
      //if video permission is not granted
      return handleAskVideoPermission(dispatch);
    } else {
      // if Both Permission is denied.
      return handleAskPermission(dispatch);
    }
  } catch (error) {
    dispatch('Camera & Mircrohpne permission is required');
    console.error('Error requesting camera permission:', error);
    return false;
  }
}

const handleAskPermission = async (dispatch) => {
  try {
    const askforpermission = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    });
    const videoTracks = askforpermission.getTracks();
    videoTracks.forEach((track) => {
      track.stop();
    });
    return true;
  } catch (error) {
    console.error('[handleAskPermission]:', error);
    dispatch(`Camera & Microphone permission is required !`);
    return false;
  }
};

const handleAskAudioPermission = async (dispatch) => {
  try {
    const askforpermission = await navigator.mediaDevices.getUserMedia({ audio: true });
    const Tracks = askforpermission.getTracks();
    Tracks.forEach((track) => {
      track.stop();
    });
    return true;
  } catch (error) {
    console.error('[handleAskAudioPermission]:', error);
    dispatch(`Microphone permission is required !`);
    return false;
  }
};

const handleAskVideoPermission = async (dispatch) => {
  try {
    const askforpermission = await navigator.mediaDevices.getUserMedia({ video: true });
    const Tracks = askforpermission.getTracks();
    Tracks.forEach((track) => {
      track.stop();
    });
    return true;
  } catch (error) {
    console.error('[handleAskVideoPermission]:', error);
    dispatch(`Camera permission is required !`);
    return false;
  }
};
